import React from 'react';
import { Chip } from '@mui/material';
import { colors } from '../styles/tokens';

const TONES = {
  success: { bg: colors.successBg, fg: colors.success },
  warning: { bg: colors.warningBg, fg: colors.warning },
  error: { bg: colors.errorBg, fg: colors.error },
  info: { bg: colors.infoBg, fg: colors.info },
  brand: { bg: colors.beige, fg: colors.goldText },
  neutral: { bg: '#F0EEEA', fg: colors.text },
};

/** Small coloured status label. `tone` is success | warning | error | info | brand | neutral. */
const StatusChip = ({ label, tone = 'neutral', sx }) => {
  if (!label) {
    return null;
  }
  const { bg, fg } = TONES[tone] || TONES.neutral;
  return <Chip size="small" label={label} sx={{ backgroundColor: bg, color: fg, fontWeight: 600, ...sx }} />;
};

export default StatusChip;
